module.exports = __webpack_public_path__ + "static/media/flyier.a8150c6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Offer/flyier.png
// module id = 401
// module chunks = 0